import React, { useState,useEffect } from 'react';

import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';
import useSanity from '../../customHooks/useSanity';
import Lottie from "lottie-react";
import UnderConstruction from "../../assets/animation_lmkutn2i.json";

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
	const [loading, setLoading] = useState(false);
	
const {contacts} = useSanity()

  const { username, email, message } = formData;

 const handleUnderConstruction = () => {
    setLoading(true); // Set loading to true

    setTimeout(() => {
      setLoading(false); // Set loading back to false after 10 seconds
    }, 10000); // 10000 milliseconds (10 seconds)
  }
  
    
    

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };


  return (
		<>
			{loading ? (
				<Lottie animationData={UnderConstruction} />
			) : (
				<>
					<h2 className="head-text">
						Take a coffee & chat with me
					</h2>
					<div className="app__footer-cards">
						<div className="app__footer-card ">
							<img src={images.email} alt="email" />
							<a
								href={`
          mailto:${contacts.email}?subject=Hello Taimoor&body=Hi Taimoor, I am writing to you because...
          `}
								className="p-text"
							>
								{contacts.email}
							</a>
						</div>
						<div className="app__footer-card">
							<img src={images.mobile} alt="phone" />
							<a
								href={`tel:${contacts.phoneNumber}`}
								className="p-text"
							>
								{contacts.phoneNumber}
							</a>
						</div>
					</div>
					{!isFormSubmitted ? (
						<div className="app__footer-form app__flex">
							<div className="app__flex">
								<input
									className="p-text"
									required
									type="text"
									placeholder="Your Name"
									name="username"
									value={username}
									onChange={handleUnderConstruction}
								/>
							</div>
							<div className="app__flex">
								<input
									className="p-text"
									required
									type="email"
									placeholder="Your Email"
									name="email"
									value={email}
									onChange={handleUnderConstruction}
								/>
							</div>
							<div>
								<textarea
									className="p-text"
									placeholder="Your Message"
									value={message}
									name="message"
									required
									onChange={handleUnderConstruction}
								/>
							</div>
							<button
								type="button"
								className="p-text"
								onClick={handleUnderConstruction}
							>
								{!loading
									? "Send Message"
									: "Sending..."}
							</button>
						</div>
					) : (
						<div>
							<h3 className="head-text">
								Thank you for getting in touch!
							</h3>
						</div>
					)}
				</>
			)}
		</>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
